import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function JewelMasterSplash() {
  const [fade, setFade] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFade(true), 3000);

    const endTimer = setTimeout(() => {
      sessionStorage.setItem("jewelMasterSplashShown", "true");
      navigate("/jewel-master/home", { replace: true });
    }, 5000);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(endTimer);
    };
  }, [navigate]);

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        backgroundImage: `url(${require("../../assets/icons/jewel-master-splash.gif")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
        animation: fade ? "fadeOut 0.6s ease forwards" : "none",
      }}
    >
      <Typography
        sx={{
          color: "#fff",
          fontWeight: 700,
          mb: 2,
          px: 4,
          py: 2,
          backgroundColor: "rgba(0,0,0,0.35)",
          borderRadius: 2,
        }}
      >
        Kumudu Software Solutions Pvt. Ltd.
      </Typography>

      <style>
        {`
          @keyframes fadeOut {
            from { opacity: 1; }
            to { opacity: 0; }
          }
        `}
      </style>
    </Box>
  );
}
